import { Component, OnInit, signal, inject, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EcorrUsaBannerComponent } from '../ecorr-usa-banner/ecorr-usa-banner.component';

@Component({
    selector: 'app-ecorr-header',
    templateUrl: './ecorr-header.component.html',
    standalone: true,
    imports: [CommonModule, MatToolbarModule, MatProgressSpinnerModule, EcorrUsaBannerComponent]
})
export class EcorrHeaderComponent implements OnInit {
    private destroyRef = inject(DestroyRef);

    // Signal-based state management
    currentUrl = signal<string>('');
    loading = signal<boolean>(false);

    constructor() { }

    ngOnInit(): void {
        // Component initialization logic can go here
    }

    focusOnMain(): void {
        const mainContent: HTMLElement | null = document.querySelector('#main');
        if (mainContent) {
            mainContent.focus();
        }
    }
}
